<template lang="html">
  <h1 class="title">Personal details</h1>
  <input
    v-model="firstName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="First name"
    required
  />
  <input
    v-model="lastName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Last name"
    required
  />
  <input
    v-model="email"
    class="form-control field no-focusborder"
    type="email"
    ref="inputfield"
    placeholder="Email address"
    required
  />
  {{ validateEmail }}
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-primary text-light btn-lg"
      :disabled="isDisabled == true"
      @click="setPersonalData()"
    >
      Next
    </button>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName && this.lastName && this.email) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          return false;
        }
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setEmail", this.email);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 40px;
  color: #6bc1d0;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  width: 100%;
  padding: 10px;
  font-size: 1.25rem;
  border-radius: 0px;
  text-align: center;
  margin-bottom: 20px;
  color: #fff;
  background-color: #9e9ea0;
}
.field::placeholder {
  color: #666;
}
</style>
